var exports = {
  "vK": "ChannelFollowModal.module__banner___V19iNE",
  "Wp": "ChannelFollowModal.module__patternImage___V19iNE",
  "JE": "ChannelFollowModal.module__bannerRow___V19iNE",
  "QE": "ChannelFollowModal.module__sourceGuildIcon___V19iNE",
  "AQ": "ChannelFollowModal.module__sourceChip___V19iNE",
  "fS": "ChannelFollowModal.module__sourceChipIcon___V19iNE",
  "jl": "ChannelFollowModal.module__sourceChipName___V19iNE",
  "Qs": "ChannelFollowModal.module__content___V19iNE",
  "Lv": "ChannelFollowModal.module__intro___V19iNE",
  "DD": "ChannelFollowModal.module__title___V19iNE",
  "h_": "ChannelFollowModal.module__description___V19iNE",
  "aK": "ChannelFollowModal.module__hint___V19iNE",
  "p$": "ChannelFollowModal.module__emptyState___V19iNE",
  "By": "ChannelFollowModal.module__guildOption___V19iNE",
  "XN": "ChannelFollowModal.module__guildAvatar___V19iNE",
  "oM": "ChannelFollowModal.module__guildAvatarPlaceholder___V19iNE",
  "ed": "ChannelFollowModal.module__optionLabel___V19iNE",
  "TN": "ChannelFollowModal.module__channelOption___V19iNE",
  "p": "ChannelFollowModal.module__channelIcon___V19iNE",
  "yb": "ChannelFollowModal.module__categoryName___V19iNE",
};

module.exports = exports;
